var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M9.81366 4.43907C10.0621 4.18569 10.0621 3.80562 9.81366 3.55224L6.45963 0.194973C5.87992 -0.396244 4.98965 0.490582 5.59006 1.0818L7.55694 3.0666C7.72257 3.23552 7.66046 3.36221 7.43271 3.36221L0.621118 3.36221C0.269151 3.36221 -1.90726e-07 3.6367 -1.75035e-07 3.99566C-1.59345e-07 4.35461 0.269151 4.6291 0.621118 4.6291L7.41201 4.6291C7.63975 4.6291 7.70186 4.75579 7.53623 4.92471L5.56936 6.90951C4.98965 7.50073 5.85921 8.40867 6.43892 7.79634L9.81366 4.43907Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.62491309d3642753a9cc36299ed881a5.svg";
export { ForwardRef as ReactComponent };